import type { ProductFlagValues } from '../../../../../../shared/ProductFlipperFlag.service';
import {
  DARKLY_PRODUCT_FLAGS,
  LEGACY_AD_LINK_MANAGER,
  LEGACY_QUICK_LINK_ANALYTICS,
  LEGACY_QUICK_LINK_MANAGER,
} from '../../../../../../shared/constants';

export type DimensionToProductsMapType = Map<string, any>;

export const DimensionProductMapping: DimensionToProductsMapType = new Map<
  string,
  {
    enabled: boolean;
    condition: (flags: ProductFlagValues) => boolean;
  }
>([
  [
    'last_attributed_touch_data_tilde_id',
    {
      enabled: true,
      condition: (flags: ProductFlagValues) => {
        if (flags[DARKLY_PRODUCT_FLAGS.QUICK_LINKS]) {
          return true;
        }

        return (
          ((flags[LEGACY_QUICK_LINK_MANAGER] || flags[LEGACY_AD_LINK_MANAGER]) && flags[LEGACY_QUICK_LINK_ANALYTICS]) ||
          (!flags[LEGACY_QUICK_LINK_MANAGER] && !flags[LEGACY_AD_LINK_MANAGER]) ||
          false
        );
      },
    },
  ],
]);
